import React, { useState, useMemo, useEffect } from "react";
import Navbarsticky from "./NavbarSticky";
import Footer from "./Footer";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MdDeleteForever } from "react-icons/md";
import DatePicker from "react-datepicker";
import { parseISO, isValid } from "date-fns";
export default function Ferry() {
  const navigate = useNavigate();

  // Places
  const PLACES = {
    PORT_BLAIR: "Port Blair",
    SWARAJ: "Swaraj Dweep (Havelock)",
    SHAHEED: "Shaheed Dweep (Neil)",
  };

  const DESTS_BY_ORIGIN = {
    [PLACES.PORT_BLAIR]: [PLACES.SWARAJ, PLACES.SHAHEED],
    [PLACES.SWARAJ]: [PLACES.PORT_BLAIR, PLACES.SHAHEED],
    [PLACES.SHAHEED]: [PLACES.PORT_BLAIR, PLACES.SWARAJ],
  };

  const ALL_PLACES = Object.values(PLACES);
  const today = new Date().toISOString().split("T")[0];

  // Tabs
  const [tab, setTab] = useState("oneway");

  // One Way state
  const [from, setFrom] = useState(PLACES.PORT_BLAIR);
  const [to, setTo] = useState(PLACES.SWARAJ);
  const [date, setDate] = useState(today);
  const [adults, setAdults] = useState(1);
  const [infants, setInfants] = useState(0);

  // Round Trip Static Row
  const [staticRow, setStaticRow] = useState({
    id: "static-1",
    from: PLACES.PORT_BLAIR,
    to: PLACES.SWARAJ,
    date: "",
    adults: 1,
    infants: 0,
  });

  // Dynamic Row Template
  const makeRow = () => ({
    id: crypto.randomUUID(),
    from: PLACES.SWARAJ,
    to: PLACES.SHAHEED,
    date: "",
    adults: 1,
    infants: 0,
  });

  const [dynamicRows, setDynamicRows] = useState([
    makeRow(),
    makeRow(PLACES.NEIL, PLACES.HAVLOCK),
  ]);

  // Update a dynamic row
  const updateRow = (id, key, value) => {
    setDynamicRows((prev) =>
      prev.map((r) => (r.id === id ? { ...r, [key]: value } : r)),
    );
  };
  // Delete row
  const deleteRow = (id) =>
    setDynamicRows(dynamicRows.filter((r) => r.id !== id));

  // One-way destination options
  const toOptions = useMemo(() => DESTS_BY_ORIGIN[from], [from]);

  useEffect(() => {
    if (!toOptions.includes(to)) {
      setTo(toOptions[0]);
    }
  }, [from, toOptions]);

  // Format date to DD-MM-YYYY
  const formatDateDDMMYYYY = (iso) => {
    if (!iso) return "";
    const [yyyy, mm, dd] = iso.split("-");
    return `${dd}-${mm}-${yyyy}`;
  };

  // Validation
  const validate = () => {
    if (from === to) return false;
    if (!date) return false;
    if (adults < 1) return false;
    return true;
  };

  // Search
  const handleSearch = () => {
    if (!validate()) return;

    const payload = {
      tripType: tab,
      source: from,
      destination: to,
      date: formatDateDDMMYYYY(date),
      adults,
      infants,
    };

    navigate("/ferrybooking", { state: payload });
  };

  const formatDateISO = (d) => {
    if (!d) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const getTodayDate = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const getStartDate = getTodayDate;

  function getTodayPlaceholder() {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${dd}-${mm}-${yyyy}`;
  }

  return (
    <>
      {/* Navbar */}
      <Navbarsticky />

      <div
        className={`ferry-container container-fluid ${tab === "round" ? "round-active" : ""}`}
      >
        <div className="ferry-card" style={{ marginTop: "5rem" }}>
          <Container className="ferry-ui-box">
            {/* Tabs */}
            <div className="trip-tabs">
              <button
                className={`trip-tab ${tab === "oneway" ? "active" : ""}`}
                onClick={() => setTab("oneway")}
              >
                <span className="tab-circle">
                  {tab === "oneway" ? "✔" : ""}
                </span>
                One Way
              </button>

              <button
                className={`trip-tab ${tab === "round" ? "active" : ""}`}
                onClick={() => setTab("round")}
              >
                <span className="tab-circle">{tab === "round" ? "✔" : ""}</span>
                Round Trip
              </button>
            </div>

            {/* ----------------> One Way UI <---------------- */}
            {tab === "oneway" && (
              <div className="oneway-row">
                {/* From */}
                <div className="input-block">
                  <label className="top-label">From</label>
                  <select
                    value={from}
                    onChange={(e) => setFrom(e.target.value)}
                    className="ferry-input"
                  >
                    {ALL_PLACES.map((p) => (
                      <option key={p}>{p}</option>
                    ))}
                  </select>
                </div>

                {/* To */}
                <div className="input-block">
                  <label className="top-label">To</label>
                  <select
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                    className="ferry-input"
                  >
                    {toOptions.map((p) => (
                      <option key={p}>{p}</option>
                    ))}
                  </select>
                </div>

                {/* Travel Date */}
                <div className="input-block">
                  <label className="top-label">Travel Date</label>

                  <DatePicker
                    selected={date ? parseISO(date) : null}
                    onChange={(d) => setDate(d ? formatDateISO(d) : "")}
                    minDate={getStartDate()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    dateFormat="dd-MM-yyyy"
                    className="ferry-input"
                    calendarClassName="ferry-datepicker-calendar"
                    placeholderText={getTodayPlaceholder()}
                  />
                </div>

                {/* Adults + Infants */}
                <div className="adults-infants-row">
                  <div className="input-block" style={{ marginRight: "5px" }}>
                    <label className="top-label">Adults</label>
                    <input
                      type="number"
                      min="1"
                      max="15"
                      value={adults}
                      onChange={(e) => setAdults(Number(e.target.value))}
                      className="ferry-input small-number-input"
                    />
                  </div>

                  <div className="input-block" style={{ marginRight: "5px" }}>
                    <label className="top-label">Infants</label>
                    <input
                      type="number"
                      min="0"
                      max="15"
                      value={infants}
                      onChange={(e) => setInfants(Number(e.target.value))}
                      className="ferry-input small-number-input"
                    />
                  </div>
                </div>

                {/* Search */}
                <div className="search-btn-wrap my-4">
                  <button className="search-btn-large" onClick={handleSearch}>
                    Search
                  </button>
                </div>
              </div>
            )}

            {/* ----------------> Round Trip UI <---------------- */}
            {tab === "round" && (
              <>
                {/* Static Row */}
                <div className="round-row">
                  {/* From */}
                  <div className="input-block">
                    <label className="top-label">From</label>
                    <select
                      className="ferry-input"
                      value={staticRow.from}
                      onChange={(e) =>
                        setStaticRow({ ...staticRow, from: e.target.value })
                      }
                    >
                      {ALL_PLACES.map((p) => (
                        <option key={p}>{p}</option>
                      ))}
                    </select>
                  </div>

                  {/* To */}
                  <div className="input-block">
                    <label className="top-label">To</label>
                    <select
                      className="ferry-input"
                      value={staticRow.to}
                      onChange={(e) =>
                        setStaticRow({ ...staticRow, to: e.target.value })
                      }
                    >
                      {DESTS_BY_ORIGIN[staticRow.from].map((p) => (
                        <option key={p}>{p}</option>
                      ))}
                    </select>
                  </div>

                  {/* Date */}
                  <div className="input-block">
                    <label className="top-label">Travel Date</label>

                    <DatePicker
                      selected={
                        staticRow.date ? parseISO(staticRow.date) : null
                      }
                      onChange={(d) =>
                        setStaticRow({
                          ...staticRow,
                          date: d ? formatDateISO(d) : "",
                        })
                      }
                      minDate={getStartDate()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      dateFormat="dd-MM-yyyy"
                      className="ferry-input"
                      calendarClassName="ferry-datepicker-calendar"
                      placeholderText={getTodayPlaceholder()}
                    />
                  </div>

                  <div className="adults-infants-row">
                    <div className="input-block">
                      <label className="top-label">Adults</label>
                      <input
                        type="number"
                        min="1"
                        max="15"
                        className="ferry-input small-number-input"
                        value={staticRow.adults}
                        onChange={(e) =>
                          setStaticRow({
                            ...staticRow,
                            adults: Number(e.target.value),
                          })
                        }
                      />
                    </div>

                    <div className="input-block">
                      <label className="top-label">Infants</label>
                      <input
                        type="number"
                        min="0"
                        max="15"
                        className="ferry-input small-number-input"
                        value={staticRow.infants}
                        onChange={(e) =>
                          setStaticRow({
                            ...staticRow,
                            infants: Number(e.target.value),
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                {/* Dynamic Rows */}
                {dynamicRows.map((r) => (
                  <div className="round-row" key={r.id}>
                    {/* From */}
                    <div className="input-block">
                      <label className="top-label">From</label>
                      <select
                        className="ferry-input"
                        value={r.from}
                        onChange={(e) => {
                          updateRow(r.id, "from", e.target.value);
                          updateRow(
                            r.id,
                            "to",
                            DESTS_BY_ORIGIN[e.target.value][0],
                          );
                        }}
                      >
                        {ALL_PLACES.map((p) => (
                          <option key={p}>{p}</option>
                        ))}
                      </select>
                    </div>

                    {/* To */}
                    <div className="input-block">
                      <label className="top-label">To</label>
                      <select
                        className="ferry-input"
                        value={r.to}
                        onChange={(e) => updateRow(r.id, "to", e.target.value)}
                      >
                        {DESTS_BY_ORIGIN[r.from].map((p) => (
                          <option key={p}>{p}</option>
                        ))}
                      </select>
                    </div>

                    {/* Date */}
                    <div className="input-block">
                      <label className="top-label">Travel Date</label>

                      <DatePicker
                        selected={r.date ? parseISO(r.date) : null}
                        onChange={(d) =>
                          updateRow(r.id, "date", d ? formatDateISO(d) : "")
                        }
                        minDate={getStartDate()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        dateFormat="dd-MM-yyyy"
                        className="ferry-input"
                        calendarClassName="ferry-datepicker-calendar"
                        placeholderText={getTodayPlaceholder()}
                      />
                    </div>

                    <div className="adults-infants-row">
                      <div className="input-block">
                        <label className="top-label">Adults</label>
                        <input
                          type="number"
                          min="1"
                          max="15"
                          className="ferry-input small-number-input"
                          value={r.adults}
                          onChange={(e) =>
                            updateRow(r.id, "adults", Number(e.target.value))
                          }
                        />
                      </div>

                      {/* Delete Row */}
                      <span
                        className="trash-icon"
                        onClick={() => deleteRow(r.id)}
                      >
                        <MdDeleteForever />
                      </span>

                      <div className="input-block">
                        <label className="top-label">Infants</label>
                        <input
                          type="number"
                          min="0"
                          max="15"
                          className="ferry-input small-number-input"
                          value={r.infants}
                          onChange={(e) =>
                            updateRow(r.id, "infants", Number(e.target.value))
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))}

                {/* Search */}
                <div className="search-btn-wrap my-4">
                  <button className="search-btn-large" onClick={handleSearch}>
                    Search
                  </button>
                </div>
              </>
            )}
          </Container>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </>
  );
}
